import { useEffect, useState } from "react";
import PhoneBook from "../../styles/svg/wpu/phoneBook.svg";
import About from "../../styles/svg/wpu/about.svg";
import User from "../../styles/svg/wpu/user.svg";
import Transport from "../../styles/svg/wpu/transport.svg";
import Dentist from "../../styles/svg/wpu/dentist.svg";
import ContactUs from "../../styles/svg/wpu/contactUs.svg";
import DragNDrop from "../../styles/svg/wpu/dragNDrop.svg";
import Chat from "../../styles/svg/wpu/chat.svg";
import CircularMenuHeader from "../GeneralHeader/GeneralHeader";
import CircularMenu from "./circularMenuComponents/CircularMenu";
import CopyRightFooter from "../CopyRightFooter/CopyRightFooter";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/userContext";
import app from "./styles/app.module.css";

const CircularMenuContainer = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const {x,setX} = useState("Hello")

const getLocation = ()=>{
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showPosition);
  } else {
    setX(()=>{return "Geolocation is not supported by this browser."}) 
  }
}
const showPosition = (position)=> {
  setX(()=>{return  "Latitude: " + position.coords.latitude +
  "  Longitude: " + position.coords.longitude});
  console.log(position.coords.latitude,position.coords.longitude,position)
}

  useEffect(() => {
    if (user !== "admin") navigate("/");
    getLocation()
  }, [navigate, user, getLocation]);

  return (
    <div className="appContainer">
      <header className="appHeader">
        <CircularMenuHeader />
      </header>
      <main className="appBody">
        <div className={app.appcontents}>
          <CircularMenu
            pages={[
              [
                "حول تطبيقات الجامعة الوطنية",
                "transparent",
                "var(--yellow)",
                About,
              ],
              [
                "الطلاب المسجلين في النقل",
                "transparent",
                "var(--yellow)",
                Transport,
                "/transport",
              ],
              [
                "دليل الهاتف",
                "transparent",
                "var(--yellow)",
                PhoneBook,
                "/wpuphones",
              ],
              ["تحميل الى المخدم", "transparent", "var(--yellow)", DragNDrop],
              ["محادثة مباشرة", "transparent", "var(--yellow)", Chat],
              ["تغيير المستخدم", "transparent", "var(--yellow)", User, "/"],
              [
                "المؤتمر السنوي لطب الأسنان",
                "transparent",
                "var(--yellow)",
                Dentist,
                "/dentistconference",
              ],
              ["اتصل بنا", "transparent", "var(--yellow)", ContactUs],
            ]}
          />

          <div className={app.guide}>
            {x? <h2 >Your Location - {x}</h2>:""}
            <h1>اضغط في منتصف الدائره أعلاه </h1>
            <h1>لتبدأ الرحلة</h1>
          </div>
        </div>
      </main>
      <footer className="appFooter">
        <CopyRightFooter />
      </footer>
    </div>
  );
};

export default CircularMenuContainer;
